import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Avatar,
  Stack,
} from "@mui/material";
import { useTranslation } from "../../../../hooks/useTranslation";
import { OrderItem } from "../../types";
import { CopiableChip } from "../../../../components/ui/CopiableChip";

type Props = {
  items: OrderItem[];
  currencyCode?: string;
};

export const OrderItemsTable = ({ items, currencyCode }: Props) => {
  const { translate } = useTranslation("pages.orderDetails");

  return (
    <Box
      sx={{
        overflowX: "auto",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        borderLeft: "4px solid",
        borderLeftColor: "primary.main",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "action.hover" }}>
            <TableCell />
            <TableCell sx={{ fontWeight: 600 }}>
              {translate("orderItems.productName")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600 }}>
              {translate("orderItems.asin")}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>
              {translate("orderItems.price")}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>
              {translate("orderItems.quantity")}
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>
                <Avatar
                  variant="rounded"
                  src={item.imageUrl}
                  alt={item.productName}
                  sx={{ width: 56, height: 56 }}
                />
              </TableCell>

              <TableCell>
                <Stack spacing={0.3}>
                  <Typography variant="body2" fontWeight={500}>
                    {item.productName}
                  </Typography>
                </Stack>
              </TableCell>

              <TableCell>
                <CopiableChip initialLabel={item.productCode.toUpperCase()} />
              </TableCell>

              <TableCell align="right">
                <Typography variant="body2" fontWeight={500}>
                  {item.unitPrice.toFixed(2)} {currencyCode}
                </Typography>
              </TableCell>

              <TableCell align="right">
                <Typography variant="body2" fontWeight={600}>
                  {item.quantity}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};
